export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_PAGINATION = 'SET_PAGINATION'

// reducer
export const PAGINATION_STATE_KEY = 'pagination'
